// src/views/Login.vue
<template>
  <div class="login-view container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-sm overflow-hidden border-0 rounded-lg">
          <!-- Optional: Add a Card Header -->
          <!-- <div class="card-header bg-primary text-white text-center">
            <h2 class="h4 mb-0">Connexion / Inscription</h2>
          </div> -->

          <div class="card-body p-4 p-md-5"> <!-- More padding -->
             <h2 class="text-center mb-4 h4 text-primary">Connexion / Inscription</h2>

            <form @submit.prevent="handleAuthAction">
              <div class="mb-3"> <!-- Use mb-3 for spacing -->
                <label for="email" class="form-label">Email</label>
                <input type="email" class="form-control" id="email" v-model="email" required placeholder="nom@exemple.com">
              </div>
              <div class="mb-4"> <!-- More space before buttons -->
                <label for="password" class="form-label">Mot de passe</label>
                <input type="password" class="form-control" id="password" v-model="password" required placeholder="Votre mot de passe">
              </div>

              <!-- Action Buttons -->
              <div class="d-grid gap-2 mb-3"> <!-- d-grid for full-width buttons -->
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ loading ? 'Connexion...' : 'Se connecter' }}
                </button>
                 <button type="button" @click="handleSignup" class="btn btn-success" :disabled="loading">
                   <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                   {{ loading ? 'Inscription...' : 'S\'inscrire' }}
                 </button>
              </div>

              <!-- Messages -->
              <div v-if="message" class="mt-3 alert alert-sm py-2 text-center" :class="{ 'alert-danger': isError, 'alert-success': !isError }" role="alert">
                {{ message }}
              </div>

            </form>
          </div>
           <!-- Optional: Add links for password reset etc. in card footer -->
           <!-- <div class="card-footer text-center small py-3">
               <a href="#">Mot de passe oublié ?</a>
           </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { supabase } from '../../supabase.js'; // Correct path using alias

const email = ref('');
const password = ref('');
const loading = ref(false);
const message = ref('');
const isError = ref(false);

// handleAuthAction for Login (Submit)
const handleAuthAction = async () => {
  loading.value = true; message.value = ''; isError.value = false;
  try {
    const { error } = await supabase.auth.signInWithPassword({ email: email.value, password: password.value });
    if (error) throw error;
    // Redirection handled by App.vue
  } catch (error) { console.error("Login Error:", error); message.value = `Erreur: ${error.message || error}`; isError.value = true; }
  finally { loading.value = false; }
};

// handleSignup for Signup button
const handleSignup = async () => {
    loading.value = true; message.value = ''; isError.value = false;
    try {
        const { data, error } = await supabase.auth.signUp({ email: email.value, password: password.value });
        if (error) throw error;
        if (data.user && !data.session) { message.value = "Inscription réussie ! Vérifiez vos emails."; isError.value = false; }
        else if (data.user && data.session) { message.value = "Inscription réussie !"; isError.value = false; /* Redirection handled by App.vue */ }
        else { message.value = "Inscription envoyée."; isError.value = true; }
    } catch (error) { console.error("Signup Error:", error); message.value = `Erreur: ${error.message || error}`; isError.value = true; }
    finally { loading.value = false; }
};

</script>

<style scoped>

/* Optional: Style the spinner */
.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: 0.15em;
}
.alert-sm {
    font-size: 0.85em;
}
</style>